import type { BlogRecord } from '@/lib/blocks/collection/records';

export enum BlogWidgetVariant {
  LIST = 'list',
  GRID = 'grid',
  CARDS = 'cards',
}

export interface BlogWidgetProps {
  title?: string;
  blogs: BlogRecord[];
}
